import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import { Split } from '../split';
export var ScaleComponent =
/*#__PURE__*/
function (_Split) {
  _inherits(ScaleComponent, _Split);

  function ScaleComponent(name, typeWithExplicit) {
    var _this;

    _classCallCheck(this, ScaleComponent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ScaleComponent).call(this, {}, // no initial explicit property
    {
      name: name // name as initial implicit property

    }));
    _this.merged = false;
    _this.domains = [];

    _this.setWithExplicit('type', typeWithExplicit);

    return _this;
  }

  return ScaleComponent;
}(Split);